var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.795 16.906L9.72995 18.915C9.37195 19.263 8.77295 19.109 8.62795 18.631L7.25195 14.101",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1038 10.927C14.1038 10.927 11.5148 13.263 10.1868 14.462C9.78983 14.82 9.82283 15.45 10.2528 15.767L15.6308 19.74C16.1598 20.131 16.9158 19.844 17.0528 19.2L19.6938 6.75299C19.8218 6.15099 19.2308 5.64799 18.6568 5.86899L3.14183 11.853C2.68483 12.029 2.70683 12.682 3.17383 12.828L7.25083 14.1",
    stroke: "#A5A5A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.be30c92ff14ee0fc5f042b4ffbb018d7.svg";
export { ForwardRef as ReactComponent };